export default __webpack_public_path__ + "static/media/material-natural.19021966.png";